import { makeStyles } from '@material-ui/core'

const confirmPassword = '& > .MuiFormControl-root:nth-of-type(2)'

const useStyles = makeStyles((theme) => ({
  form: ({ isModifiedMode }: { isModifiedMode?: boolean }) => ({
    '& > div': {
      width: '100%',
    },

    [confirmPassword]: {
      marginBottom: isModifiedMode ? '24px' : '32px',
    },
  }),
  recaptcha: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '68px',
    background: '#d7d7d7',
    marginBottom: '32px',
    color: theme.variables.fontColorGray,
  },
  modifiedHeplerText: {
    marginTop: '5px',
    marginBottom: '16px',
    fontSize: theme.variables.fontSizeSm,
    color: theme.variables.fontColorBlack,
  },
  heplerText: {
    fontSize: theme.variables.fontSizeSm,
    marginTop: 0,
    marginBottom: '16px',
  },
  heplerTextError: {
    color: 'red',
    fontSize: theme.variables.fontSizeSm,
  },
  mainTitle: ({ isModifiedMode }: { isModifiedMode?: boolean }) => ({
    textAlign: isModifiedMode ? 'left' : 'center',
    fontSize: theme.variables.fontSizeXl,
    fontWeight: theme.variables.fontWeight600,
    marginTop: isModifiedMode ? '12px' : 0,
    marginBottom: isModifiedMode ? '24px' : '32px',
    color: theme.variables.fontColorBlack,
  }),
  label: {
    fontSize: theme.variables.fontSizeLg,
    fontWeight: theme.variables.fontWeight600,
    color: theme.variables.deepBlue,
  },
}))

export default useStyles
